function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect, useRef } from 'react';
import without from 'lodash/without';
import PropTypes from 'prop-types';
import Recaptcha from 'react-google-invisible-recaptcha';
import { Checkbox } from '@domain-group/fe-blueprint-ui/form';
import { validEmail } from '@domain-group/fe-helper';
import { ProfileIcon, PhoneIcon, EmailIcon, PinIcon } from '@domain-group/fe-co-icon';
import { withSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button, Separator } from '@domain-group/fe-co-allhomes-design-system';
import { ContactField, CommentField, Promotion, AddressSelector, AgentList } from './components';
import sendEnquiry from './utils/send-enquiry';
import { appearancePropTypes, showSubheadings, isListingAppearance, isWatchlistAppearance, isAppraisalAppearance } from './utils/appearance';
import validatePhoneNumber from './utils/validate-phone-number';
import { container as promotionContainerStyle } from './components/promotion.style';
import styleFactory from './allhomes-enquiry-form.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var REQUIRED = '*';
var OTHER = {
  id: 'OTHER',
  value: 'OTHER',
  label: 'Others'
};
var AllhomesEnquiryForm = props => {
  var _props$agencies, _props$agencies$filte, _props$agents;
  var contactFieldsConfig = {
    name: {
      label: 'Full Name',
      icon: ProfileIcon,
      required: true,
      requiredError: 'Please enter your full name',
      validate: () => {}
    },
    phone: {
      label: 'Phone Number',
      icon: PhoneIcon,
      required: false,
      validate: (value, contactFields) => {
        if (!value) {
          var _contactFields$email;
          if (!(contactFields !== null && contactFields !== void 0 && (_contactFields$email = contactFields.email) !== null && _contactFields$email !== void 0 && _contactFields$email.value)) {
            return 'Please enter your phone number and/or your email';
          }
        }
        return !validatePhoneNumber(value) && 'Please enter a valid phone number';
      }
    },
    email: {
      label: 'Email',
      icon: EmailIcon,
      required: false,
      validate: (value, contactFields) => {
        if (!value) {
          var _contactFields$phone;
          if (!(contactFields !== null && contactFields !== void 0 && (_contactFields$phone = contactFields.phone) !== null && _contactFields$phone !== void 0 && _contactFields$phone.value)) {
            return 'Please enter your phone number and/or your email';
          }
          return '';
        }
        return validEmail(value) ? '' : 'Invalid email address';
      }
    },
    postcode: {
      label: 'Postcode',
      icon: PinIcon,
      required: false,
      validate: value => !value || /^\d{4}$/.test(value) ? '' : 'Invalid postcode'
    }
  };
  var allFields = Object.keys(contactFieldsConfig);
  var initialContactState = allFields.reduce((fields, key) => _objectSpread(_objectSpread({}, fields), {}, {
    [key]: {
      value: '',
      error: ''
    }
  }), {});
  var _useState = useState(initialContactState),
    _useState2 = _slicedToArray(_useState, 2),
    contactFields = _useState2[0],
    setContactFields = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    wsResultText = _useState4[0],
    setWsResultText = _useState4[1];
  var _useState5 = useState(new Set()),
    _useState6 = _slicedToArray(_useState5, 2),
    reasons = _useState6[0],
    setReasons = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    comments = _useState8[0],
    setComments = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    displayComment = _useState0[0],
    setDisplayComment = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    sendMeCopy = _useState10[0],
    setSendMeCopy = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    disableSubmit = _useState12[0],
    setDisableSubmit = _useState12[1];
  var _useState13 = useState(props.formData),
    _useState14 = _slicedToArray(_useState13, 2),
    formData = _useState14[0],
    setFormData = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    address = _useState16[0],
    setAddress = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    hasError = _useState18[0],
    setHasError = _useState18[1];
  var enquiryFormRef = useRef(null);
  var recaptchaRef = useRef(null);
  var formDataBeforeRecaptcha = useRef(null);
  var styles = styleFactory(props.appearance);
  var agencies = (_props$agencies = props.agencies) === null || _props$agencies === void 0 ? void 0 : (_props$agencies$filte = _props$agencies.filter(item => item.agency.isEmailContactable)) === null || _props$agencies$filte === void 0 ? void 0 : _props$agencies$filte.slice(0, 2);
  var agents = (_props$agents = props.agents) === null || _props$agents === void 0 ? void 0 : _props$agents.filter(item => item.agent.isEmailContactable);
  useEffect(() => {
    var _enquiryFormRef$curre;
    var elements = ((_enquiryFormRef$curre = enquiryFormRef.current) === null || _enquiryFormRef$curre === void 0 ? void 0 : _enquiryFormRef$curre.elements) || null;
    if (elements) {
      Object.keys(elements).forEach(index => {
        elements[index].tabIndex = 0;
      });
    }
  }, []);
  var getFieldValue = key => contactFields[key].value;
  var shouldDisplayPromotion = () => isListingAppearance(props.appearance) && props.sponsorship;
  var doSend = data => {
    props.sendEnquiry(props.endpointUrl, data).then(response => {
      if (response.emailHash) {
        var _props$onEnquirySent;
        props.sendEvent('send-enquiry', _objectSpread(_objectSpread({}, data), {}, {
          options: [...reasons],
          enquiryFormVersion: 'v2'
        }));
        setWsResultText('Your enquiry is sent!');
        (_props$onEnquirySent = props.onEnquirySent) === null || _props$onEnquirySent === void 0 ? void 0 : _props$onEnquirySent.call(props, response.emailHash);
        if (shouldDisplayPromotion()) {
          props.sendEvent('sponsorship-viewed');
        }
      }
    }).catch(() => {
      setWsResultText('Error connecting to server. Please try again later.');
      setHasError(true);
    });
  };
  var getData = () => _objectSpread(_objectSpread({}, formData), {}, {
    name: getFieldValue('name'),
    emailAddress: getFieldValue('email'),
    phone: getFieldValue('phone'),
    postcode: getFieldValue('postcode'),
    comments,
    sendMeCopy,
    options: without([...reasons], OTHER.id),
    ua: navigator.userAgent
  }, isAppraisalAppearance(props.appearance) && {
    listingAddress: address
  });
  var onCaptchaResolved = () => {
    doSend(_objectSpread(_objectSpread({}, formDataBeforeRecaptcha.current), {}, {
      token: recaptchaRef.current.getResponse(),
      reCaptchaType: 'invisible'
    }));
  };
  var validateField = (key, value) => {
    var field = contactFieldsConfig[key];
    var error = field.required && !value.length ? field.requiredError : field.validate(value, contactFields);
    return {
      value,
      error: error || ''
    };
  };
  var validate = () => {
    var newFields = allFields.reduce((acc, key) => {
      acc[key] = validateField(key, contactFields[key].value);
      return acc;
    }, {});
    setContactFields(newFields);
    return !Object.keys(newFields).some(key => newFields[key].error);
  };
  var submitForm = () => {
    if (!validate()) {
      var _recaptchaRef$current;
      (_recaptchaRef$current = recaptchaRef.current) === null || _recaptchaRef$current === void 0 ? void 0 : _recaptchaRef$current.reset();
      return;
    }

    // Capture form data before reCAPTCHA
    var capturedData = getData();
    if (props.recaptchaSiteKey) {
      // Store captured data in ref
      formDataBeforeRecaptcha.current = capturedData;
      recaptchaRef.current.execute();
    } else {
      doSend(capturedData);
    }
  };
  var handleFieldChange = (key, value) => {
    setContactFields(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [key]: validateField(key, value)
    }));
  };
  var handleOptionChange = event => {
    var newReasons = new Set(reasons);
    if (event.target.checked) {
      newReasons.add(event.target.value);
    } else {
      newReasons.delete(event.target.value);
    }
    setReasons(newReasons);
    setDisplayComment(!props.enableMessage && newReasons.has(OTHER.id));
  };
  var handleCommentChange = evt => {
    setComments(evt.target.value);
  };
  var handleSendMeCopy = evt => {
    setSendMeCopy(evt.target.checked);
  };
  var resetForm = () => {
    setWsResultText('');
    setContactFields(initialContactState);
    setComments('');
    setDisplayComment(false);
    setDisableSubmit(false);
    setHasError(false);
  };
  var handleDone = () => {
    resetForm();
    props.onDoneClick();
  };
  var renderCommentField = () => ___EmotionJSX(CommentField, {
    fieldValue: comments,
    onValueChange: handleCommentChange,
    placeholder: props.messagePlaceholder,
    appearance: props.appearance
  });
  var renderSendMeCopyField = () => ___EmotionJSX("div", {
    css: styles.sendCopyWrapper
  }, ___EmotionJSX(Checkbox, {
    name: "sendCopy",
    id: "COPY",
    onChange: handleSendMeCopy,
    labelContent: "Send me a copy of the enquiry",
    css: styles.checkbox
  }));
  var renderAppraisalSegment = () => ___EmotionJSX("div", {
    css: styles.addressAgents
  }, ___EmotionJSX(AddressSelector, {
    handleAddress: setAddress
  }), ___EmotionJSX(AgentList, {
    type: formData.type,
    agencies: agencies,
    agents: agents,
    handleDisableSubmit: setDisableSubmit,
    handleFormData: setFormData
  }));
  var isPromotionOrListingOrWatchlist = () => shouldDisplayPromotion() || isListingAppearance(props.appearance) || isWatchlistAppearance(props.appearance);
  var displayHeader = () => ___EmotionJSX("div", {
    css: styles.header
  }, ___EmotionJSX("div", {
    css: styles.title
  }, wsResultText !== '' && isPromotionOrListingOrWatchlist() ? '' : props.formTitle));
  var displayLogo = () => props.logoUrl && ___EmotionJSX("div", {
    css: styles.header
  }, ___EmotionJSX("img", {
    src: props.logoUrl,
    alt: "",
    css: styles.logo
  }));
  var renderFormSubmitResult = () => ___EmotionJSX("div", {
    css: styles.successMessageContainer
  }, isPromotionOrListingOrWatchlist() && !hasError ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: styles.promotionSuccessMessage
  }, "Thank you for your interest in\xA0", ___EmotionJSX("span", {
    css: styles.address
  }, props.listingAddress), ", your enquiry has now been sent to the agent."), ___EmotionJSX("div", {
    css: styles.promotionResetButtonGroup
  }, ___EmotionJSX(Button, {
    css: styles.resetButton,
    appearance: "outline",
    onClick: handleDone
  }, props.doneText))) : ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: styles.successMessage
  }, wsResultText), ___EmotionJSX("div", {
    css: styles.resetButtonGroup
  }, ___EmotionJSX(Button, {
    css: styles.resetButton,
    appearance: "outline",
    onClick: handleDone
  }, props.doneText))));
  var renderContactField = key => {
    var field = contactFieldsConfig[key];
    var fieldState = contactFields[key];
    return ___EmotionJSX(ContactField, {
      icon: field.icon,
      fieldName: key,
      placeHolder: "".concat(field.label).concat(field.required ? REQUIRED : ''),
      onValueChange: event => handleFieldChange(key, event.target.value),
      fieldError: fieldState.error,
      fieldValue: fieldState.value,
      appearance: props.appearance
    });
  };
  var renderContactFields = () => {
    var table = styles.table,
      row = styles.row,
      leftCol = styles.leftCol,
      rightCol = styles.rightCol;
    return ___EmotionJSX("div", {
      css: table
    }, ___EmotionJSX("div", {
      css: row
    }, ___EmotionJSX("div", {
      css: leftCol
    }, renderContactField('name')), ___EmotionJSX("div", {
      css: rightCol
    }, renderContactField('phone'))), ___EmotionJSX("div", {
      css: row
    }, ___EmotionJSX("div", {
      css: leftCol
    }, renderContactField('email')), ___EmotionJSX("div", {
      css: rightCol
    }, renderContactField('postcode'))));
  };
  var renderReasonCheckBoxes = () => {
    var checkboxes = props.options.map(option => ___EmotionJSX("li", {
      key: option.id
    }, ___EmotionJSX(Checkbox, {
      name: option.value,
      id: option.id,
      value: option.value,
      onChange: handleOptionChange,
      labelContent: option.label,
      css: styles.checkbox
    })));
    return ___EmotionJSX("div", null, showSubheadings(props.appearance) && ___EmotionJSX("div", {
      css: styles.sectionTitle
    }, "What would you like to enquire about?"), ___EmotionJSX("ul", {
      css: styles.checkboxColumns
    }, checkboxes, props.enableOther && ___EmotionJSX("li", {
      key: OTHER.id
    }, ___EmotionJSX(Checkbox, {
      name: OTHER.value,
      id: OTHER.id,
      value: OTHER.value,
      onChange: handleOptionChange,
      labelContent: OTHER.label,
      css: styles.checkbox
    }))));
  };
  var renderFormContent = () => ___EmotionJSX(React.Fragment, null, ((agencies === null || agencies === void 0 ? void 0 : agencies.length) > 0 || (agents === null || agents === void 0 ? void 0 : agents.length) > 0) && renderAppraisalSegment(), ___EmotionJSX("form", {
    ref: enquiryFormRef
  }, !isAppraisalAppearance(props.appearance) && renderReasonCheckBoxes(), displayComment && renderCommentField(), showSubheadings(props.appearance) && ___EmotionJSX("div", {
    css: styles.sectionTitle
  }, "Your contact details"), renderContactFields(), props.enableMessage && renderCommentField(), props.enableSendMeCopy && renderSendMeCopyField(), ___EmotionJSX("div", {
    css: styles.separator
  }, ___EmotionJSX(Separator, null)), ___EmotionJSX("div", {
    css: styles.buttonGroup
  }, props.recaptchaSiteKey && ___EmotionJSX(Recaptcha, {
    ref: recaptchaRef,
    sitekey: props.recaptchaSiteKey,
    onResolved: onCaptchaResolved
  }), ___EmotionJSX(Button, {
    css: styles.button,
    onClick: submitForm,
    disabled: disableSubmit
  }, "Send Enquiry")), props.disclaimer && ___EmotionJSX("div", {
    css: styles.disclaimer
  }, props.disclaimer), props.recaptchaSiteKey && ___EmotionJSX("div", {
    css: styles.disclaimer
  }, "This site is protected by reCAPTCHA and the Google", ' ', ___EmotionJSX("a", {
    href: "https://policies.google.com/privacy"
  }, "Privacy Policy"), " and", ' ', ___EmotionJSX("a", {
    href: "https://policies.google.com/terms"
  }, "Terms of Service"), ' ', "apply.")));
  return ___EmotionJSX("section", {
    css: styles.enquiryForm
  }, ___EmotionJSX("div", {
    css: styles.container
  }, displayLogo(), displayHeader(), wsResultText === '' ? renderFormContent() : renderFormSubmitResult()), !shouldDisplayPromotion() && isListingAppearance(props.appearance) && wsResultText !== '' && ___EmotionJSX("div", {
    css: promotionContainerStyle(undefined)
  }), shouldDisplayPromotion() && wsResultText !== '' && ___EmotionJSX(Promotion, props.sponsorship.enquirySection));
};
AllhomesEnquiryForm.propTypes = {
  appearance: appearancePropTypes.isRequired,
  endpointUrl: PropTypes.string.isRequired,
  recaptchaSiteKey: PropTypes.string,
  formTitle: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  disclaimer: PropTypes.string,
  doneText: PropTypes.string,
  messagePlaceholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })),
  enableOther: PropTypes.bool,
  enableSendMeCopy: PropTypes.bool,
  enableMessage: PropTypes.bool,
  formData: PropTypes.shape({
    agencyId: PropTypes.number,
    ids: PropTypes.arrayOf({
      id: PropTypes.number
    }),
    type: PropTypes.string
  }),
  sendEnquiry: PropTypes.func,
  onEnquirySent: PropTypes.func,
  onDoneClick: PropTypes.func,
  sendEvent: PropTypes.func,
  listingAddress: PropTypes.string,
  sponsorship: PropTypes.shape({
    enquirySection: PropTypes.shape({})
  }),
  agencies: PropTypes.arrayOf({
    agency: PropTypes.shape({})
  }),
  agents: PropTypes.arrayOf({
    agent: PropTypes.shape({})
  })
};
AllhomesEnquiryForm.defaultProps = {
  logoUrl: null,
  onEnquirySent: () => {},
  recaptchaSiteKey: '',
  disclaimer: null,
  onDoneClick: () => {},
  options: [],
  doneText: 'Reset form',
  messagePlaceholder: 'Message',
  enableMessage: false,
  enableSendMeCopy: false,
  enableOther: false,
  sendEnquiry,
  formData: {},
  sendEvent: () => {},
  listingAddress: '',
  sponsorship: {},
  agencies: [],
  agents: []
};
export { AllhomesEnquiryForm as BaseAllhomesEnquiryForm };
export default withSendEvent(AllhomesEnquiryForm);